import { useGenericFilters } from '@/hooks/generic/useGenericFilters';
import { Company } from './useCompanies';

export function useCompanyFilters(companies: Company[]) {
  const filterHook = useGenericFilters<Company>(companies, {
    searchFields: ['name', 'industry', 'city'],
    multiSelectFilters: {
      companyType: { field: 'company_type', matchLogic: 'any' },
      status: { field: 'status', matchLogic: 'any' },
      tradeSpecialties: { field: 'trade_specialties', matchLogic: 'any' },
      prequalificationStatus: { field: 'prequalification_status', matchLogic: 'any' },
    },
  });

  return {
    searchQuery: filterHook.filters.search || '',
    setSearchQuery: filterHook.setSearch,
    companyTypeFilter: (filterHook.filters.companyType?.[0] as string) || 'all',
    setCompanyTypeFilter: (val: string) => 
      filterHook.updateFilters({ companyType: val === 'all' ? [] : [val] }),
    statusFilter: (filterHook.filters.status?.[0] as string) || 'all',
    setStatusFilter: (val: string) => 
      filterHook.updateFilters({ status: val === 'all' ? [] : [val] }),
    tradeSpecialtiesFilter: (filterHook.filters.tradeSpecialties?.[0] as string) || 'all',
    setTradeSpecialtiesFilter: (val: string) => 
      filterHook.updateFilters({ tradeSpecialties: val === 'all' ? [] : [val] }),
    prequalificationStatusFilter: (filterHook.filters.prequalificationStatus?.[0] as string) || 'all',
    setPrequalificationStatusFilter: (val: string) => 
      filterHook.updateFilters({ prequalificationStatus: val === 'all' ? [] : [val] }),
    filteredCompanies: filterHook.filteredItems,
  };
}
